import React, { Component } from "react";

import { Link, Redirect } from "react-router-dom";

import { connect } from "react-redux";
import { firestoreConnect } from "react-redux-firebase";
import { compose } from "redux";

import Logo from "../assets/images/logo.png";
import Menu from "../assets/svg/menu-light.svg";

import MenuFunc from "./Menu";
import { Helmet } from "react-helmet";

class History extends Component {
  state = {
    menuToggled: false,
  };

  componentDidMount() {}

  setmenuoff = (wot) => {
    this.setState({ menuToggled: wot });
  };

  parsedate = (seconds) => {
    let d = new Date(seconds * 1000);
    let options = {
      weekday: "long",
      year: "numeric",
      month: "long",
      day: "numeric",
    };
    return d.toLocaleDateString("en-US", options);
  };

  render() {
    const { auth, logs, profile } = this.props;
    if (JSON.parse(localStorage.getItem('isPremium')) === true) {
        profile.isPremium = true;
    }
    if (!auth.uid) return <Redirect to="/" />;
    if (!profile.isPremium) return <Redirect to="/upgrade" />;

    return (
      <div>
        <Helmet>
          <title>Workout History</title>
          <meta
            name="description"
            content="BoxFit est l'application d'entraînement ultime à domicile
    avec plus de 390 exercices vidéo, 10 catégories d'entraînement différentes et premium,
    des fonctionnalités telles que l'historique d'entraînement et le radar de poids."
          />

          <meta property="og:url" content="https://www.boxfit-fitness.com/history" />
          <meta property="og:title" content="BoxFit" />
          <meta
            property="og:description"
            content="BoxFit est l'application d'entraînement ultime à domicile
    avec plus de 390 exercices vidéo, 10 catégories d'entraînement différentes et premium,
    des fonctionnalités telles que l'historique d'entraînement et le radar de poids."
          />
          <meta property="og:site_name" content="BoxFit" />
          <meta
            property="og:image"
            content="https://www.boxfit-fitness.com/images/sharer.png"
          />
          <meta property="og:type" content="profile" />
          <meta property="og:locale" content="en_US" />
        </Helmet>
        <div style={{ position: "relative" }}>
          <MenuFunc display={this.state.menuToggled} off={this.setmenuoff} />

          <div
            style={{
              zIndex: 999,
              position: "absolute",
              top: "15px",
              left: "20px",
            }}
          >
            <Link
              to={{
                pathname: "/",
                query: {
                  fromMenu: true,
                },
              }}
            >
              <img src={Logo} alt="logo" style={{ maxHeight: "45px" }}></img>
            </Link>
          </div>

          <div
            style={{
              position: "absolute",
              top: "25px",
              right: "22px",
              zIndex: 999,
            }}
            onClick={() => {
              this.setmenuoff(true);
            }}
          >
            <img src={Menu} alt="logo" style={{ maxHeight: "25px" }}></img>
          </div>
        </div>

        <div
          className="Screen"
          style={
            {
              /*height: "800px",
            width: "450px",
            borderRadius: "20px",
            boxShadow: "2px 2px 120px rgba(255, 255, 255, 0.15)",
            backgroundColor: "#000",*/
            }
          }
        >
          <div>
            <div style={{ height: "60px" }}></div>
            <div style={{ padding: "0px 20px 20px 20px" }}>
              <h2
                style={{
                  fontSize: "28px",
                  color: "#69C9D0",
                  borderRadius: "2px",
                }}
              >
                Workout History
              </h2>

              <div>
                {logs && logs.length > 0 ? (
                  <table className="table">
                    <thead>
                      <tr className="tableh">
                        <th>Date</th>
                        <th>Workout</th>
                        <th>Calories</th>
                      </tr>
                    </thead>
                    <tbody>
                      {logs ? (
                        logs.map((obj, i, arr) => {
                          return (
                            <tr key={i}>
                              <td>{this.parsedate(obj.when.seconds)}</td>
                              <td>{obj.category.toUpperCase()}</td>
                              <td>{obj.calories}</td>
                            </tr>
                          );
                        })
                      ) : (
                        <tr></tr>
                      )}
                    </tbody>
                  </table>
                ) : (
                  <p
                    style={{
                      fontSize: "20px",
                      color: "#fff",
                    }}
                  >
                    No workout to display yet. Click{" "}
                    <Link style={{ color: "white" }} to="/select-workout">
                      here
                    </Link>{" "}
                    to exercise now.
                  </p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  const exelogs = state.firestore.ordered["workout-logs"];
  const exelog = exelogs ? exelogs : [];

  console.log(exelog);

  return {
    auth: state.firebase.auth,
    profile: state.firebase.profile,
    logs: exelog,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  firestoreConnect((props) => [
    {
      collection: "workout-logs",
      where: [["user", "==", props.auth.uid || ""]],
      orderBy: [["when", "desc"]],
    },
  ])
)(History);
